import { apiRequest } from '../lib/httpClient'

type AdvisoryAccessResponse = boolean
type BillingAccessResponse = boolean | { hasBillingAccess?: boolean }

export type AuthzContextResponse = {
  subject?: {
    userId?: string
    userTypeId?: number
    clientId?: string
    clientTypeId?: number
  }
  permissions?: string[]
  constraints?: {
    platformTypes?: number[]
    featureFlags?: Record<string, boolean>
    clientVisibility?: {
      showAdvisoryMapping?: boolean
      showProjectStatus?: boolean
    }
    // Old spelling on purpose — this is the field the server sends.
    advisePrepPaywall?: {
      active?: boolean
      reason?: 'signup_incomplete' | 'past_due' | 'subscription_ended'
      since?: string | null
    } | null
  }
  defaultRoute?: string
  version?: string
}

export async function fetchRolePermissions(clientType: number, clientId: string): Promise<string[]> {
  const payload = await apiRequest<unknown>('role/ui/roles/getroles', {
    method: 'GET',
    query: { clientType, clientId },
  })

  if (!Array.isArray(payload)) return []
  return payload.filter((value): value is string => typeof value === 'string')
}

export async function fetchAdvisoryMappingAccess(clientId: string): Promise<boolean> {
  const payload = await apiRequest<AdvisoryAccessResponse>('advisorymapping/ui/advisoryMapping/access', {
    method: 'GET',
    query: { clientId },
  })
  return Boolean(payload)
}

export async function fetchBillingAccess(clientId: string): Promise<boolean> {
  const payload = await apiRequest<BillingAccessResponse>('client/ui/billing/access', {
    method: 'GET',
    query: { clientId },
  })
  if (typeof payload === 'boolean') return payload
  return Boolean(payload?.hasBillingAccess)
}

export async function fetchAuthzContext(clientId: string): Promise<AuthzContextResponse> {
  return apiRequest<AuthzContextResponse>('authz/ui/context', {
    method: 'GET',
    query: { clientId },
  })
}
